import { AppConstant } from '../supports/app.constant'
import Swal from "sweetalert2";
import dayjs from 'dayjs'
import {ErrorMessageConstant, ErrorText} from "@/supports/error-message.constant.js";
interface timeObject {
  year: number
  month: number
  day: number
  hours: number
  minutes: number
  seconds: number
}

export default new (class CommonService {
  /**
   * Get token current user login
   */
  getTokenAuth() {
    return localStorage.getItem(AppConstant.KEY_ACCESS_TOKEN);
  }

  /**
   * Get refresh token current user login
   */
  getRefreshTokenAuth() {
    return localStorage.getItem(AppConstant.REFRESH_TOKEN);
  }

  getUserName() {
    return localStorage.getItem(AppConstant.KEY_USERNAME);
  }

  getUserId() {
    return localStorage.getItem(AppConstant.KEY_USERID);
  }

  getUserOffice() {
    // return localStorage.getItem(AppConstant.KEY_USER_OFFICE);
  }

  getCompanyId() {
    return localStorage.getItem(AppConstant.KEY_COMPANY_ID);
  }

  getUserHeadOffice() {
    // return parseInt(localStorage.getItem(AppConstant.HEAD_OFFICE_CLASS));
  }

  /**
   * Set token and refresh token current user login
   * @param token
   */
  setTokenAuth(token: any) {
    if (token) {
      this.setAccessToken(token.accessToken)
      this.setCookieToken(token.refreshToken, 'refresh_token')
      localStorage.setItem(AppConstant.REFRESH_TOKEN, token.refreshToken);
      localStorage.setItem(AppConstant.KEY_USERNAME, token.username);
      localStorage.setItem(AppConstant.KEY_USERID, token.userid);
      localStorage.setItem(AppConstant.KEY_COMPANY_ID, token.company_id);
      localStorage.setItem(AppConstant.KEY_COMPANY_CODE, token.company_zip);
      localStorage.setItem(AppConstant.KEY_COMPANY_NAME, token.company_name);
    }
  }

  /**
   * Set token current user login
   * @param token
   */
  setAccessToken(token: any) {
    localStorage.setItem(AppConstant.KEY_ACCESS_TOKEN, token);
    this.setCookieToken(token)
  }

  /**
   * Set cookie token current user login
   * @param token
   * @param name
   */
  setCookieToken(token: any, name = 'access_token') {
    const date = new Date()
    date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000)
    const expires = 'expires=' + date.toUTCString()
    document.cookie = name + '=' + token + ';' + expires + ';path=/'
  }

  /**
   * Clear all auth token in local storage
   */
  clearTokenAuth() {
    localStorage.clear()
    document.cookie = 'access_token=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
    document.cookie = 'refresh_token=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
  }

  /**
   * Check string only is number (for all languages)
   *
   * @param input
   */
  checkOnlyNumeric(input: string): boolean {
    return /^[\p{N}\p{Nd}]+$/u.test(input)
  }

  /**
   * Download PDF file
   *
   * @param data
   * @param name
   *
   */
  downloadPdf(data: any, name: string) {
    const url = window.URL.createObjectURL(new Blob([data.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', name)
    document.body.appendChild(link)
    link.click()
  }

  /**
   * Focus input with v-model
   *
   * @param id
   * @param el
   */
  focusInput(id: string, el: any) {
    el.$nextTick(() => {
      // @ts-ignore
      document.getElementById(id).focus()
    })
  }

  /**
   * check empty string or object
   *
   * @param param
   */
  isEmpty(param: any) {
    if (typeof param === 'string') {
      return param.trim().length === 0
    }
    if (typeof param === 'object') {
      return Object.keys(param).length === 0
    }
  }

  /**
   * convert string to date type Y-m-d
   *
   * @param dateString
   */
  convertDate(dateString: string) {
    if (dateString) {
      const date = new Date(dateString)
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()

      return String(day).padStart(2, '0') + '-' + String(month).padStart(2, '0') + '-' + year
    }
    return ''
  }

  /**
   * convert string to date type Y-m-d H:i
   *
   * @param dateString
   */
  convertDateTime(dateString: string) {
    if (dateString) {
      const date = new Date(dateString)
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()

      const minute = date.getMinutes();
      const hour = date.getHours();

      return String(day).padStart(2, '0') + '-' + String(month).padStart(2, '0') + '-' + year + ' ' + String(hour).padStart(2, '0') + ':' + String(minute).padStart(2, '0')
    }
    return ''
  }

  /**
   * convert date to string type Y-m-d
   *
   * @param date
   */
  convertDateToString(date: Date) {
    if (date) {
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()

      return year + '-' + String(month).padStart(2, '0') + '-' + String(day).padStart(2, '0')
    }
    return ''
  }

  /**
   * Compare object value month-picker format in vuedatepicker
   *
   * @param objFrom
   * @param objTo
   *
   * @param equal
   */
  compareObjectsByTime(objFrom: timeObject, objTo: timeObject, equal: boolean = false) {
    const date1 = new Date(
      objFrom.year || 0,
      objFrom.month || 0,
      objFrom.day || 0,
      objFrom.hours || 0,
      objFrom.minutes || 0,
      objFrom.seconds || 0
    )
    const date2 = new Date(
      objTo.year || 0,
      objTo.month || 0,
      objTo.day || 0,
      objTo.hours || 0,
      objTo.minutes || 0,
      objTo.seconds || 0
    )

    if ((equal && date1.getTime() == date2.getTime()) || date1.getTime() > date2.getTime()) {
      return false
    }
    return true
  }

  /**
   * deep clone in javascript for arrays or objects
   *
   * @param data
   */
  deepClone(data: any) {
    return JSON.parse(JSON.stringify(data))
  }

  /**
   * Compare value priority partner with label
   *
   * @param priority
   */
  comparePriorityPartner(priority: number) {
    switch (priority) {
      case AppConstant.PARTNER_PRIORITY_NORMAL:
        return 'Thông thường';
      case AppConstant.PARTNER_PRIORITY_NECESSARY:
        return 'Cần thiết';
      case AppConstant.PARTNER_PRIORITY_INTERESTED:
        return 'Quan tâm';
      case AppConstant.PARTNER_PRIORITY_SIGNIFICANT:
        return 'Quan trọng';
      case AppConstant.PARTNER_PRIORITY_VIP:
        return 'VIP';
    }
  }

  /**
   * Compare value priority partner with label background
   *
   * @param priority
   */
  comparePriorityPartnerBackground(priority: number) {
    switch (priority) {
      case AppConstant.PARTNER_PRIORITY_NORMAL:
        return '#E8F0FE';
      case AppConstant.PARTNER_PRIORITY_NECESSARY:
        return '#FEF7E0';
      case AppConstant.PARTNER_PRIORITY_INTERESTED:
        return '#FFF3E0';
      case AppConstant.PARTNER_PRIORITY_SIGNIFICANT:
        return '#FDECEF';
      case AppConstant.PARTNER_PRIORITY_VIP:
        return '#EDE7F6';
    }
  }

  /**
   * Compare value priority partner with label background
   *
   * @param priority
   */
  comparePriorityPartnerColorText(priority: number) {
    switch (priority) {
      case AppConstant.PARTNER_PRIORITY_NORMAL:
        return '#1A73E8';
      case AppConstant.PARTNER_PRIORITY_NECESSARY:
        return '#F9AB00';
      case AppConstant.PARTNER_PRIORITY_INTERESTED:
        return '#FB8C00';
      case AppConstant.PARTNER_PRIORITY_SIGNIFICANT:
        return '#D93025';
      case AppConstant.PARTNER_PRIORITY_VIP:
        return '#5E35B1';
    }
  }

  /**
   * Compare value status partner with label
   *
   * @param status
   */
  compareStatusPartner(status: number) {
    switch (status) {
      case AppConstant.PARTNER_STATUS_NON_CONNECT:
        return 'Chưa kết nối';
      case AppConstant.PARTNER_STATUS_INVITE:
        return 'Đã mời';
      case AppConstant.PARTNER_STATUS_REFUSE:
        return 'Đã từ chối';
      case AppConstant.PARTNER_STATUS_CONNECTED:
        return 'Đã kết nối';
    }
  }

  /**
   * Compare value status partner with label background
   *
   * @param status
   */
  compareStatusPartnerBackground(status: number) {
    switch (status) {
      case AppConstant.PARTNER_STATUS_NON_CONNECT:
        return '#F1F3F4';
      case AppConstant.PARTNER_STATUS_INVITE:
        return '#FEF7E0';
      case AppConstant.PARTNER_STATUS_REFUSE:
        return '#FDECEA';
      case AppConstant.PARTNER_STATUS_CONNECTED:
        return '#E6F4EA';
    }
  }

  /**
   * Compare value status partner with label background
   *
   * @param status
   */
  compareStatusPartnerColorText(status: number) {
    switch (status) {
      case AppConstant.PARTNER_STATUS_NON_CONNECT:
        return '#5F6368';
      case AppConstant.PARTNER_STATUS_INVITE:
        return '#F9AB00';
      case AppConstant.PARTNER_STATUS_REFUSE:
        return '#D93025';
      case AppConstant.PARTNER_STATUS_CONNECTED:
        return '#188038';
    }
  }

  /**
   * show alert popup
   *
   * @param params
   */
  showAlertPopup(params: any) {
   return Swal.fire({
      title: params.title,
      icon: params.icon,
      showConfirmButton: params.showConfirmButton,
      showCancelButton: params.showCancelButton ?? false,
      timer: params.timer,
      width: params.width
    });
  }

  /**
   * show alert confirm popup
   *
   * @param params
   */
  showAlertConfirmPopup(params: any) {
    return Swal.fire({
      title: params.title,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "Đồng ý",
      cancelButtonText: "Huỷ bỏ",
      width: params.width
    });
  }

  /**
   * check time expired connect cooperate
   *
   * @param time
   */
  checkTimeExpiredConnect(time: string) {
    const timeStartConnect = new Date(time);
    const secondsStartConnect = timeStartConnect.getTime() / 1000
    const timeCurrent = new Date();
    const secondsCurrent = timeCurrent.getTime() / 1000
    return AppConstant.TIME_EXPIRED_TOKEN_CONNECTION - (secondsStartConnect - secondsCurrent) > 0;
  }

  /**
   * validate email
   *
   * @param email
   */
  validateEmail(email: string) {
    return /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(email);
  };

  validatePassword(password: string) {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).+$/.test(password);
  };

  isNaturalNumberStr(s: string, allowZero = true) {
    const re = allowZero ? /^(?:0|[1-9]\d*)$/ : /^[1-9]\d*$/;
    return re.test(s.trim());
  }

  validateDecimal(decimal: number) {
    return /^-?\d*(\.\d+)?$/.test(String(decimal));
  };

  formatDate(dateTime: string) {
    if (!dateTime) {
      return '';
    }
    const date = new Date(dateTime);
    const yr = date.getFullYear();
    const mo = date.getMonth() + 1;
    const day = date.getDate();

    return (day < 10 ? '0' + day : day) + '-' + (mo < 10 ? '0' + mo : mo)  + '-' + yr;
  }

  formatPrice(price: number, currency: string) {
    if(!price) {
      price = 0;
    }
    if(!currency) {
      currency = 'VND';
    }
    return new Intl.NumberFormat('it-IT', { style: 'currency', currency: currency }).format(price);
  }

  /**
   * Compare value status delivery with label
   *
   * @param status
   */
  compareStatusDeliveryLabel(status: number) {
    switch (status) {
      case AppConstant.DELIVERY_STATUS_SENT:
        return 'Đã gửi';
      case AppConstant.DELIVERY_STATUS_IN_PROCESS:
        return 'Đang xác minh';
      case AppConstant.DELIVERY_STATUS_APPROVED:
        return 'Đã chấp thuận';
      case AppConstant.DELIVERY_STATUS_REJECT:
        return 'Đã huỷ';
    }
  }

  /**
   * Compare value status delivery with label background
   *
   * @param status
   */
  compareStatusDeliveryBackground(status: number) {
    switch (status) {
      case AppConstant.DELIVERY_STATUS_REJECT:
        return '#ff4d4d';
      case AppConstant.DELIVERY_STATUS_APPROVED:
        return '#ffaa05';
      case AppConstant.DELIVERY_STATUS_IN_PROCESS:
        return '#4d3900';
      case AppConstant.DELIVERY_STATUS_SENT:
        return '#54ba4a';
    }
  }

  /**
   * show dropdown action
   *
   * @param type
   */
  showDropdownAction(type: number) {
    const dropdown = {
      id: 'action_common',
      label: '',
      placeholder: 'Lựa chọn hành động',
      value: '',
      options: [
        {
          name: 'Xoá',
          value: AppConstant.ACTION_TYPE_DELETE
        },
      ],
      required: false
    }
    switch (type) {
      case AppConstant.DROPDOWN_ACTION_COMMON:
        return dropdown;
      case AppConstant.DROPDOWN_ACTION_FORMAT_FILE:
        dropdown.id = 'action_format_file'
        dropdown.options = [
          {
            name: 'Kích hoạt sử dụng',
            value: AppConstant.ACTION_ENABLE_FORMAT_FILE
          },
          {
            name: 'Tải file sử dụng',
            value: AppConstant.ACTION_DOWNLOAD_FORMAT_FILE
          },
        ]
        return dropdown;
      case AppConstant.DROPDOWN_ACTION_PRODUCT:
        dropdown.id = 'action_product'
        dropdown.options = [
          {
            name: 'Xoá',
            value: AppConstant.ACTION_TYPE_DELETE
          },
          {
            name: 'Xuất file',
            value: AppConstant.ACTION_TYPE_EXPORT_EXCEL
          },
        ]
        return dropdown;
      case AppConstant.DROPDOWN_ACTION_PARTNER:
        dropdown.id = 'action_partner'
        dropdown.options = [
          {
            name: 'Xoá',
            value: AppConstant.ACTION_TYPE_DELETE
          },
          {
            name: 'Xuất file',
            value: AppConstant.ACTION_TYPE_EXPORT_EXCEL
          },
        ]
        return dropdown;
      case AppConstant.DROPDOWN_ACTION_INVITE_CONNECT:
        dropdown.id = 'action_invite'
        dropdown.options = [
          {
            name: 'Chấp nhận kết nối',
            value: AppConstant.ACTION_TYPE_ACCEPT
          },
        ]
        return dropdown;
      case AppConstant.DROPDOWN_ACTION_ARRIVAL:
        dropdown.id = 'action_arrival'
        dropdown.options = [
          {
            name: 'Cập nhập trạng thái',
            value: AppConstant.ACTION_ARRIVAL_CHANGE_STATUS
          },
          {
            name: 'Huỷ nhập kho',
            value: AppConstant.ACTION_ARRIVAL_CANCEL
          },
        ]
        return dropdown;
      case AppConstant.DROPDOWN_ACTION_PAGE:
        dropdown.id = 'action_page'
        dropdown.placeholder = 'Hiển thị 20 dữ liệu'
        dropdown.options = [
          {
            name: 'Hiển thị 10 dữ liệu',
            value: AppConstant.LIMIT_PAGE_10
          },
          {
            name: 'Hiển thị 20 dữ liệu',
            value: AppConstant.LIMIT_PAGE_20
          },
          {
            name: 'Hiển thị 50 dữ liệu',
            value: AppConstant.LIMIT_PAGE_50
          },
        ]
        return dropdown;
      case AppConstant.DROPDOWN_SYNC_KIOTVIET:
        dropdown.id = 'action_sync_kiotviet'
        dropdown.options = [
          {
            name: 'Đồng Bộ',
            value: AppConstant.ACTION_TYPE_SYNC_KIOTVIET
          },
        ]
        return dropdown;
      case AppConstant.DROPDOWN_ACTION_STORE:
        dropdown.id = 'action_store'
        dropdown.options = [
          {
            name: 'Xoá',
            value: AppConstant.ACTION_STORE_DELETE
          },
        ]
        return dropdown;
      case AppConstant.DROPDOWN_ACTION_SYNC_GHTK:
        dropdown.id = 'action_order_ghtk'
        dropdown.options = [
          {
            name: 'Kích hoạt sử dụng',
            value: AppConstant.ACTION_EN_DISABLE_GHTK
          },
        ]
        return dropdown;
      case AppConstant.DROPDOWN_ACTION_ORDER_GHTK:
        dropdown.id = 'action_order_ghtk'
        dropdown.options = [
          {
            name: 'In nhãn đơn hàng',
            value: AppConstant.ACTION_PRINT_LABELS_ORDER_GHTK
          },
          {
            name: 'Huỷ đơn hàng',
            value: AppConstant.ACTION_CANCEL_ORDER_GHTK
          },
        ]
        return dropdown;
      default:
        return dropdown;
    }
  }

  /**
   * show dropdown limit
   *
   */
  showDropdownLimitRecord() {
    return {
      id: 'limitPage',
      label: '',
      placeholder: '10',
      value: '10',
      options: [
        {
          name: '10',
          value: AppConstant.LIMIT_PAGE_10
        },
        {
          name: '20',
          value: AppConstant.LIMIT_PAGE_20
        },
        {
          name: '50',
          value: AppConstant.LIMIT_PAGE_50
        },
      ],
      required: false
    }
  }

  /**
   * Compare value type file with label
   *
   * @param status
   */
  compareTypeFileLabel(type: number) {
    switch (type) {
      case AppConstant.TYPE_FILE_EXCEL:
        return 'xlsx';
      case AppConstant.TYPE_FILE_CSV:
        return 'csv';
      case AppConstant.TYPE_FILE_PDF:
        return 'pdf';
    }
  }

  /**
   * Compare value status of format file with label
   *
   * @param status
   */
  compareStatusFormatFileLabel(status: number) {
    switch (status) {
      case AppConstant.STATUS_FORMAT_FILE_DISABLE:
        return 'Chưa kích hoạt';
      case AppConstant.STATUS_FORMAT_FILE_PUBLISH:
        return 'Đang hoạt động';
    }
  }

  /**
   * Compare value status of arrival with label
   *
   * @param status
   */
  compareStatusArrivalLabel(status: number) {
    switch (status) {
      case AppConstant.STATUS_ARRIVAL_CREATE:
        return 'Đang chuẩn bị';
      case AppConstant.STATUS_ARRIVAL_START_MOVE:
        return 'Đang di chuyển';
      case AppConstant.STATUS_ARRIVAL_FINISH_MOVE:
        return 'Đã nhập hàng';
      case AppConstant.STATUS_ARRIVAL_CANCEL:
        return 'Đã huỷ';
    }
  }

  async __delete(params: Object, url: string, store: any) {
    return await store.delete(url, params);
  }
  
  async generateIcon(icon: string) {
    try {
      const iconComponent = await import(`@/components/icons/Icon${icon.charAt(0).toUpperCase() + icon.slice(1)}.vue`);
      return iconComponent.default;
    } catch {
      return null;
    }
  }

  validateForm(value: string | number, name: string, data: any) {
    const dataObj = data.value ?? data;
    const field = dataObj[name]
    if (!field) return false

    let fieldHasError = false
    field.isError = false
    field.error = ''

    const rules = {
      required: (v: string | number) =>
          (v === null || v === undefined || v === '') && ErrorText.REQUIRED(field.label),
      maxLength: (v: string | number, max: number) => v && (typeof v === 'number' ? v.toString().length : v.length) > max && ErrorText.MAX_LENGTH(field.label, max),
      minLength: (v: string | number, min: number) => v && (typeof v === 'number' ? v.toString().length : v.length) < min && ErrorText.MIN_LENGTH(field.label, min),
      email: (v: string | number) => {
        if (!v) return false;
        const str = typeof v === 'number' ? v.toString() : v;
        return !this.validateEmail(str) && ErrorMessageConstant.ERROR_MAIL_INVALID;
      },
      phone: (v: string | number) => v && ![10, 11].includes((typeof v === 'number' ? v.toString().length : v.length)) && ErrorMessageConstant.ERROR_PHONE_LENGTH,
      decimal: (v: string | number) => {
        if (!v) return false;
        const num = typeof v === 'string' ? parseFloat(v) : v;
        return !this.validateDecimal(num) && ErrorMessageConstant.ERROR_NUMBER_INVALID;
      },
      date: (v: string | number) => v && !dayjs(v, 'DD-MM-YYYY', true).isValid() && ErrorText.INVALID(field.label),
      password: (v: string | number) => {
        if (!v) return false;
        const str = typeof v === 'number' ? v.toString() : v;
        return !this.validatePassword(str) && ErrorMessageConstant.ERROR_PASSWORD_INVALID;
      },
      naturalNumber: (v: string | number) => {
        if (!v) return false;
        const num = typeof v !== 'string' ? v.toString() : v;
        return !this.isNaturalNumberStr(num) && ErrorMessageConstant.ERROR_NUMBER_INVALID;
      },
    } as const;

    type RuleName = keyof typeof rules;

    const validations = Object.keys(dataObj).reduce((acc, key) => {
      const field = dataObj[key];
      if (Array.isArray(field.validations) && field.validations.length > 0) {
        acc[key] = field.validations;
      }
      return acc;
    }, {} as Record<string, any[]>);

    const fieldRules = validations[name] || [];

    for (const rule of fieldRules) {
      let errorMessage: false | string | "" | 0 | undefined;

      if (Array.isArray(rule)) {
        const [ruleName, param] = rule as [RuleName, number | string];
        const fn = rules[ruleName];
        if (typeof param === "number") {
          errorMessage = fn?.(value as any, param);
        }
      } else {
        const fn = rules[rule as RuleName];
        errorMessage = fn?.(value as any, 0);
      }

      if (errorMessage) {
        field.isError = true;
        field.error = errorMessage;
        fieldHasError = true;
        break;
      }
    }
    return fieldHasError;
  }

  /**
   * Compare value status of format file with label
   *
   * @param status
   */
  compareStatusSyncGHTKLabel(status: number) {
    switch (status) {
      case AppConstant.STATUS_SYNC_GHTK_INACTIVE:
        return 'Chưa kích hoạt';
      case AppConstant.STATUS_SYNC_GHTK_ACTIVE:
        return 'Đang hoạt động';
    }
  }

})()

